/**
 *
 * @component 用户中心/数据看板/项目完成率TOP5
 *
 **/

import { useHistory } from 'react-router-dom';
import BaseCard from '@/components/UserCenter/BaseCard';
import ECharts from '&/components/BaseECharts/index';
import { xBarOption } from './constants';
import './FinishRate.scss';

function FinishRate(props) {
    const { defaultValue, userId } = props;
    const [data, setData] = useState({ finish: [] });
    const { finish } = data;

    const options = {
        ...xBarOption,
        color: ['#386BF6', '#EFB353'],
        yAxis: {
            type: 'category',
            axisLabel: {
                color: 'rgba(0,0,0,0.4)',
                overflow: 'truncate',
                align: 'left',
                width: 94,
                margin: 100,
            },
            data: finish.map(e => e.name),
            axisLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#F4F6FC',
                },
            },
            boundaryGap: false,
        },
        xAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value} %',
                color: 'rgba(0, 0, 0, 0.5)',
            },
            splitLine: {
                show: false,
            },
            offset: 36,
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#E3E7F2',
                },
            },
            axisTick: {
                show: true,
                lineStyle: {
                    color: '#E3E7F2',
                },
            },
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            formatter: '{b} : {c}%',
        },
        series: [
            {
                name: '完成率',
                type: 'bar',
                itemStyle: {
                    borderRadius: 6,
                },
                barWidth: 11,
                lebel: {
                    show: true,
                },
                data: finish.map(e => +e.isFinish),
            },
        ],
    };
    options.grid.left = 120;

    useEffect(() => {
        setData(defaultValue || { finish: [] });
    }, [defaultValue]);

    const HISTORY = useHistory();
    const targetList = () => {
        const path = `/user-center/manager/status-list?manager=${userId}`;
        HISTORY.push(path);
    };

    const more = (
        <span onClick={targetList} className="type--normal native-link">
            {intl.get('base.viewMore')}
        </span>
    );
    return (
        <BaseCard
            className="finish-rate"
            title="项目完成率Top5"
            headerExtra={more}>
            <ECharts height="19.75rem" option={options}></ECharts>
        </BaseCard>
    );
}

export default FinishRate;
